/**
 * As 5 categorias de desfecho de `taxonomia-desfecho-atendimento.md`.
 *
 * ⚠️ **E desfecho do ATENDIMENTO.** Ele nasceu aqui como `AlertOutcomeEnum`, e o nome
 * estava errado: a taxonomia chama o campo de "Desfecho do Atendimento" e o
 * `04-atendimentos.md` diz que quem o exige e a acao "Concluir". O alerta **herda** o
 * desfecho do atendimento que o tratou -- por isso nao ha mais rota de resolver alerta
 * separadamente.
 */
enum AppointmentOutcomeEnum {
  RESOLVED_BY_CINCO = 'resolvido_pela_cinco',
  /** ⚠️ Fecha o alerta, mas o paciente **permanece** em acompanhamento. */
  REFERRED_TO_EMERGENCY = 'encaminhado_samu_upa',
  /** ⚠️ So se aplica a atendimento originado de alerta -- o back recusa fora disso. */
  FALSE_ALERT = 'falso_alerta',
  /**
   * ⚠️ Conclui o atendimento, mas **nao fecha** o alerta: ele volta para a fila. A
   * taxonomia diz que o caso permanece pendente ou e reagendado.
   */
  PATIENT_NOT_FOUND = 'paciente_nao_localizado',
  /**
   * ⚠️ Para atendimento **sem** alerta por tras. Se o atendimento veio de um alerta,
   * o back recusa esta opcao -- e a tela mostra a mensagem dele.
   */
  ROUTINE_COMPLETED = 'atendimento_rotina',
}

export default AppointmentOutcomeEnum;
